import createIcon from '../../createIcon';

/**
 * @component @name ScreenLockLandscape
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNUgzQzEuOSA1IDEgNS45IDEgN1YxN0MxIDE4LjEgMS45IDE5IDMgMTlIMjFDMjIuMSAxOSAyMyAxOC4xIDIzIDE3VjdDMjMgNS45IDIyLjEgNSAyMSA1Wk0xOSAxN0g1VjdIMTlWMTdaTTEwIDE2SDE0QzE0LjU1IDE2IDE1IDE1LjU1IDE1IDE1VjEyQzE1IDExLjQ1IDE0LjU1IDExIDE0IDExVjEwQzE0IDguODkgMTMuMSA4IDEyIDhDMTAuODkgOCAxMCA4LjkgMTAgMTBWMTFDOS40NSAxMSA5IDExLjQ1IDkgMTJWMTVDOSAxNS41NSA5LjQ1IDE2IDEwIDE2Wk0xMC44IDEwQzEwLjggOS4zNCAxMS4zNCA4LjggMTIgOC44QzEyLjY2IDguOCAxMy4yIDkuMzQgMTMuMiAxMFYxMUgxMC44VjEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScreenLockLandscape = createIcon('ScreenLockLandscape', [
  [
    'path',
    {
      d: 'M21 5H3C1.9 5 1 5.9 1 7V17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5ZM19 17H5V7H19V17ZM10 16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11V10C14 8.89 13.1 8 12 8C10.89 8 10 8.9 10 10V11C9.45 11 9 11.45 9 12V15C9 15.55 9.45 16 10 16ZM10.8 10C10.8 9.34 11.34 8.8 12 8.8C12.66 8.8 13.2 9.34 13.2 10V11H10.8V10Z',
      key: '1cqh4m',
    },
  ],
]);

export default ScreenLockLandscape;
